var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "logistic-work-bench" }, [
    _c("div", { staticClass: "work-bench-top" }, [
      _c("div", { staticClass: "work-bench-left-top" }, [
        _c("div", { staticClass: "work-bench-echart" }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "refreshDate" },
                [
                  _c("Icon", {
                    staticStyle: { "vertical-align": "baseline" },
                    attrs: { type: "md-alarm" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("更新时间：" + _vm._s(_vm.newTime))]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "10px",
                        color: "#3C8DBC",
                        cursor: "pointer",
                      },
                      on: { click: _vm.getList },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "endingInventoryDate" }, [
            _c(
              "ul",
              { staticClass: "manage-left" },
              _vm._l(_vm.endingInventoryDataList, function (item, index) {
                return _c("li", { key: index }, [
                  _c("span", [_vm._v(_vm._s(item.value))]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "manage-name",
                      attrs: { title: item.prompt },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", {
            staticStyle: {
              width: "100%",
              height: "260px",
              "margin-top": "20px",
            },
            attrs: { id: "main" },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.finalInventoryLoading,
                  expression: "finalInventoryLoading",
                },
              ],
              staticClass: "fromLoading",
            },
            [_c("Spin")],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "work-bench-right-top" }, [
        _c(
          "div",
          { staticClass: "selectDateR" },
          [
            _c(
              "Select",
              {
                attrs: {
                  multiple: "",
                  multipleType: "",
                  transfer: "",
                  chooseAll: "",
                },
                on: {
                  "on-change": _vm.onchange,
                  "on-open-change": _vm.warehouseChange,
                },
                model: {
                  value: _vm.warehouse,
                  callback: function ($$v) {
                    _vm.warehouse = $$v
                  },
                  expression: "warehouse",
                },
              },
              _vm._l(_vm.option, function (item, index) {
                return _c("Option", { key: index, attrs: { value: item.ID } }, [
                  _vm._v(_vm._s(item.NAME)),
                ])
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "selectWarehouseDate" }, [
          _c(
            "div",
            { staticClass: "selectDateToday" },
            [
              _c("Icon", {
                staticClass: "caption-icon",
                attrs: { type: "md-calendar" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "caption" }, [_vm._v("今日数据")]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "manage-left" },
                _vm._l(_vm.warehouseTodayDataList, function (item, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        staticClass: "manage-name",
                        attrs: { title: item.prompt },
                      },
                      [_vm._v(_vm._s(item.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.jumpOrderClick(item.key, item.value)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.value))]
                    ),
                    _vm._v(" "),
                    _c("hr", {
                      staticStyle: {
                        border: "0",
                        "background-color": "#E4E4E4",
                        height: "1px",
                        "margin-top": "5px",
                      },
                    }),
                  ])
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "selectDateYesterday" },
            [
              _c("Icon", {
                staticClass: "caption-icon",
                attrs: { type: "md-copy" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "caption" }, [_vm._v("昨日数据")]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "manage-right" },
                _vm._l(_vm.warehouseYesetdayDataList, function (item, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        staticClass: "manage-name",
                        attrs: { title: item.prompt },
                      },
                      [_vm._v(_vm._s(item.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.jumpYesterdayClick(item.key, item.value)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.value))]
                    ),
                    _vm._v(" "),
                    _c("hr", {
                      staticStyle: {
                        border: "0",
                        "background-color": "#E4E4E4",
                        height: "1px",
                        "margin-top": "5px",
                      },
                    }),
                  ])
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.warehouseLoading,
                  expression: "warehouseLoading",
                },
              ],
              staticClass: "fromLoading",
            },
            [_c("Spin")],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "work-bench-bottom" }, [
      _c(
        "div",
        { staticClass: "work-bench-bottom-today" },
        [
          _c("span", { staticClass: "overview-title" }, [
            _vm._v("今日仓库发货情况"),
          ]),
          _vm._v(" "),
          _c("define-echart", {
            staticClass: "pie-top",
            attrs: { id: "sendLogisticData", option: _vm.sendLogisticData },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "flex-end" } },
            [
              _c("define-echart", {
                staticClass: "bar-chart",
                attrs: { id: "stockBarContainer", option: _vm.stockBarData },
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "ul",
                  { staticClass: "send-logistic-total" },
                  _vm._l(_vm.sendTotalToday, function (item, index) {
                    return _c("li", { key: index }, [
                      _c("span", { staticStyle: { color: "#fd6442" } }, [
                        _vm._v(_vm._s(item.value)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "manage-name",
                          attrs: { title: item.prompt },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "send-logistic-total" },
                  _vm._l(_vm.sendTotalYesteday, function (item, index) {
                    return _c("li", { key: index }, [
                      _c("span", { staticStyle: { color: "#39b0f9" } }, [
                        _vm._v(_vm._s(item.value)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "manage-name",
                          attrs: { title: item.prompt },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.sendLogisticLoading,
                  expression: "sendLogisticLoading",
                },
              ],
              staticClass: "fromLoading",
            },
            [_c("Spin")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-bench-bottom-today" },
        [
          _c("span", { staticClass: "overview-title" }, [
            _vm._v("今日快递发货情况"),
          ]),
          _vm._v(" "),
          _c("define-echart", {
            staticClass: "pie-top",
            attrs: { id: "logisticsData", option: _vm.logisticsData },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "flex-end" } },
            [
              _c("define-echart", {
                staticClass: "bar-chart",
                attrs: {
                  id: "logisticsBarContainer",
                  option: _vm.logisticsBarData,
                },
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "ul",
                  { staticClass: "send-logistic-total" },
                  _vm._l(_vm.sendLogisticsTotalToday, function (item, index) {
                    return _c("li", { key: index }, [
                      _c("span", { staticStyle: { color: "#fd6442" } }, [
                        _vm._v(_vm._s(item.value)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "manage-name",
                          attrs: { title: item.prompt },
                        },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ])
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "send-logistic-total" },
                  _vm._l(
                    _vm.sendLogisticsTotalYesteday,
                    function (item, index) {
                      return _c("li", { key: index }, [
                        _c("span", { staticStyle: { color: "#39b0f9" } }, [
                          _vm._v(_vm._s(item.value)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "manage-name",
                            attrs: { title: item.prompt },
                          },
                          [_vm._v(_vm._s(item.name))]
                        ),
                      ])
                    }
                  ),
                  0
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.logisticsLoading,
                  expression: "logisticsLoading",
                },
              ],
              staticClass: "fromLoading",
            },
            [_c("Spin")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "work-bench-bottom-right" },
        [_c("info-list", { attrs: { info: _vm.publicInfo } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "overview-title" }, [
        _vm._v("昨日期末库存概览"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }